import { api } from 'app/api';
import { ApiResponse } from 'dtos';

export interface MoveToInvoicedFormDto {
  formId: number;
  formNumber: string;
  formStatusId: number;
  formStatus: string;
}

export interface MoveToInvoicedRequestDto {
  forms: MoveToInvoicedFormDto[];
  invoiceNumber?: string;
  overwriteInvoiceNumber: boolean;
}

export const getMoveToInvoicedForms = async (search: string): Promise<ApiResponse<MoveToInvoicedFormDto[]>> =>
  await api
    .get<ApiResponse<MoveToInvoicedFormDto[]>>('admin/move-to-invoiced', { params: { search } })
    .then(res => res.data);

export const moveFormsToInvoiced = async (request: MoveToInvoicedRequestDto): Promise<ApiResponse<null>> =>
  await api.post<ApiResponse<null>>('admin/move-to-invoiced', request).then(res => res.data);
